import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VID_KEY = 'arge_vid';

function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return 'anon';
  }
}

// Fires a first-party pageview on every route change. Renders nothing.
const Analytics = () => {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (last.current === pathname) return; // dedupe (React StrictMode double-invoke)
    last.current = pathname;
    const isFirst = !sessionStorage.getItem('arge_nav');
    sessionStorage.setItem('arge_nav', '1');
    axios.post(`${API}/track`, {
      visitor_id: getVisitorId(),
      path: pathname,
      // referrer only meaningful on the first page of the session
      referrer: isFirst ? (document.referrer || '') : '',
    }).catch(() => {});
  }, [pathname]);

  return null;
};

export default Analytics;
